import React, { useState, useEffect, useCallback } from 'react'
import styled from 'styled-components'
import { NavLink } from 'react-router-dom'
import { useActiveWeb3React } from '../../../hooks'
import { userInfo } from '../../../constants/usercenter'
import { userInfoProps } from '../../../constants/usercenter'
import { getArtist } from '../../../service/user'
import { memeList, partnerList, gameList } from '../../../constants/nft'

const BakeryFooterWrapper = styled.div`
  width: 100%;
  background: linear-gradient(171.84deg,#FFE3B3 -2.08%,#FFD48A 112.31%);
  padding: 64px 138px 0px 114px;
  position: absolute;
  overflow: hidden;
  margin-top: 120px;
  height: 381px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    padding: 64px 10px;
  `}
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    padding: 64px 10px;
    height: auto;
  `}
`
const BakeryFooterContent = styled.div`
  max-width: 1440px;
  margin: auto;
  box-sizing: border-box;
  padding: 0px 25px;
`
const FooterBg = styled.img`
  width: 465px;
  height: 203px;
  top: 0px;
  position: absolute;
  left: 772px;
  z-index: 1;
`
const BakeryLogo = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  img{
    width: 40px;
    height: 40px;
  }
  span{
    font-family: Baloo Da;
    font-style: normal;
    font-weight: normal;
    font-size: 32px;
    color: #722F0D;
    margin-left: 8px;
  }
`
const FooterContent = styled.div`
  position: relative;
  z-index: 2;
  margin-top: 40px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    flex-direction: column;
    justify-content: center;
  `}
`
const StayInLoop = styled.div``
const Title = styled.div`
  
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  color: #722F0D;
  white-space: nowrap;
`
const Desc = styled.div`
  
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #722F0D;
  opacity: 0.5;
  margin-top: 13px;
`
const InputWrapper = styled.div`
  position: relative;
  margin-top: 40px;
  width: 445px;
  input{
    width: 445px;
    height: 48px;
    line-height: 48px;
    text-indent: 15px;
    background: ${({ theme }) => theme.bsBg30};
    opacity: 0.6;
    border-radius: 50px;
    outline: none;
    border: 0px;
    padding: 2px;
  }
  span{
    display: inline-block;
    width: 99px;
    text-align: center;
    height: 42px;
    line-height: 42px;
    background: linear-gradient(285.72deg, #FFD600 -21.15%, #FF7A00 60.61%);
    border-radius: 50px;
    
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    letter-spacing: 0.02em;
    color: #FFFFFF;
    position: absolute;
    right: 3px;
    top: 3px;
    cursor: pointer;
  }
`
const NFTMarketplace = styled.div`
  margin-left: 100px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin-left: 0px;
    margin-top: 20px;
  `}
`
const SubTitle = styled(NavLink)`
  
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #9C6236;
  margin-top: 14px;
  white-space: nowrap;
  cursor: pointer;
  display: block;
  text-decoration: none;
  &:hover{
    text-decoration: underline;
  }
`
const Trade = styled.div`
  margin-left: 50px
  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin-left: 0px;
    margin-top: 20px;
  `}
`
const JoinCommunity = styled.div`
  margin-left: 120px
  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin-left: 0px;
    margin-top: 20px;
  `}
`
const JoinIcon = styled.div`
  display: flex;
  margin-top: 18px;
  img{
    width: 20px;
    height: 20px;
    margin-right: 28px;
    cursor: pointer;
  }
  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin-left: 0px;
    margin-top: 20px;
  `}
`


export default function BakeryFooter() {
  const { chainId, account} = useActiveWeb3React()

  const [artistUrl, setArtistUrl] = useState<string>('')

  // 获取艺术家数据
  const getArtistList = useCallback(() => {
    getArtist(chainId as number, {addressTypes: '4'}, (err: any, d: any) => {
      if (!err && d.code === 0) {
        const list = d.data || []
        const data = list.length ? list : userInfo
        const artists = data.map((d: userInfoProps) => {
          return{
            nick: d.nick,
            avatar: d.avatar,
            address: d.address
          }
        })
        setArtistUrl(artists[0].address)
      } else {
        setArtistUrl(userInfo[0].address)
      }
    })
  }, [chainId])

  useEffect(() => {
    getArtistList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getArtistList])

  return (
    <BakeryFooterWrapper>
      <BakeryFooterContent>
        <FooterBg src={'/images/icon/footerbg.png'}/>
        <BakeryLogo>
          <img src='/images/192x192_App_Icon.png'/>
          <span>BakerySwap</span>
        </BakeryLogo>
        <FooterContent>
          <StayInLoop>
            <Title>DeFi, NFT, GameFi and more</Title>
            <Desc>Backed by more than 100,000 holders, Bakery is the first BSC project that facilitates broad solutions for both end-users and businesses in DeFi and NFTs.</Desc>
            {
              false && (
              <InputWrapper>
                <input type="text"/>
                <span>Sign up</span>
              </InputWrapper>
              )
            }
          </StayInLoop>
          <NFTMarketplace>
            <Title>NFT Marketplace</Title>
            {
              false && (
                <>
                  <SubTitle to={`/usercenter/${artistUrl}?type=CREATED`}>Featured Artists</SubTitle>
                  <SubTitle to={`/collection/${memeList[0].urlName}`}>Mintable Artworks and Meme</SubTitle>
                  <SubTitle to={`/collection/${partnerList[0].urlName}`}>Partner Shops</SubTitle>
                  <SubTitle to={`/collection/${gameList[0].urlName}`}>Collectibles and Game Assets</SubTitle>
                </>
              )
            }
            <SubTitle to={`/collection/bsc`}>BSC Artist</SubTitle>
            <SubTitle to={`/myArtwork/bsc`}>My Artwork</SubTitle>
            <SubTitle to={`/usercenter/${account}`}>My Profile</SubTitle>
          </NFTMarketplace>
          <Trade>
            <Title>Trade</Title>
            <SubTitle to={'/swap'}>Exchange</SubTitle>
            <SubTitle to={'/pool'}>Liquidity</SubTitle>
          </Trade>
          <JoinCommunity>
            <Title>Join the community</Title>
            <JoinIcon>
              <a href="https://t.me/bakeryswap" target="_blank">
                <img src='/images/icon/Telegram.png'/>
              </a>
              <a href="https://bakeryswap.medium.com/" target="_blank">
                <img src='/images/icon/Medium.png'/>
              </a>
              <a href="https://twitter.com/bakery_swap" target="_blank">
                <img src='/images/icon/Twitter.png'/>
              </a>
            </JoinIcon>
          </JoinCommunity>
        </FooterContent>
      </BakeryFooterContent>
    </BakeryFooterWrapper>
  )
}